/* Tinkoro – interakcje sklepu (bez zewnętrznych bibliotek).
   Koszyk boczny (Shopify Cart AJAX API), warianty, przyklejony przycisk,
   powiększanie zdjęć, autoodtwarzanie filmów po przewinięciu, menu mobilne. */
(function () {
  'use strict';

  var cfg = window.Tinkoro || {};
  var routes = cfg.routes || {};
  var CART_URL = routes.cart || '/cart';
  var ADD_URL = (routes.cartAdd || '/cart/add') + '.js';
  var CHANGE_URL = (routes.cartChange || '/cart/change') + '.js';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Formatowanie ceny (zgodne z formatem waluty sklepu) ---------- */
  function formatMoney(cents) {
    var format = cfg.moneyFormat || '{{amount_with_comma_separator}} zł';
    cents = Number(cents) || 0;
    function withDelimiters(num, precision, thousands, decimal) {
      var fixed = (num / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
  }

  /* ---------- Komunikat ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('[data-tk-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 2600);
  }

  /* ---------- Koszyk boczny ---------- */
  var drawer = $('[data-tk-drawer]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) { window.location.href = CART_URL; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.classList.add('tk-lock');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      var panel = $('.tk-drawer__panel', drawer);
      if (panel) panel.focus();
    });
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('tk-lock');
    setTimeout(function () { drawer.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function renderCart(cart) {
    $$('[data-tk-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
      var link = el.closest('[data-tk-cart-open]');
      if (link) link.setAttribute('aria-label', 'Koszyk, liczba produktów: ' + cart.item_count);
    });
    if (!drawer) return;
    var list = $('[data-tk-cart-lines]', drawer);
    var empty = $('[data-tk-cart-empty]', drawer);
    var foot = $('[data-tk-cart-foot]', drawer);
    var total = $('[data-tk-cart-total]', drawer);

    list.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + esc(item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160') + '" alt="' + esc(item.product_title) + '" width="72" height="72" loading="lazy">'
        : '';
      var variant = item.product_has_only_default_variant ? '' : '<p class="tk-cart-line__variant">' + esc(item.variant_title) + '</p>';
      return (
        '<li class="tk-cart-line" data-key="' + esc(item.key) + '">' +
          '<div class="tk-cart-line__media">' + img + '</div>' +
          '<div class="tk-cart-line__info">' +
            '<p class="tk-cart-line__title">' + esc(item.product_title) + '</p>' + variant +
            '<div class="tk-qty" role="group" aria-label="Ilość: ' + esc(item.product_title) + '">' +
              '<button type="button" class="tk-qty__btn" data-tk-qty="' + (item.quantity - 1) + '" aria-label="Zmniejsz ilość">−</button>' +
              '<span class="tk-qty__val">' + item.quantity + '</span>' +
              '<button type="button" class="tk-qty__btn" data-tk-qty="' + (item.quantity + 1) + '" aria-label="Zwiększ ilość">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="tk-cart-line__end">' +
            '<p class="tk-cart-line__price">' + formatMoney(item.final_line_price) + '</p>' +
            '<button type="button" class="tk-link-btn" data-tk-qty="0">Usuń</button>' +
          '</div>' +
        '</li>'
      );
    }).join('');

    empty.hidden = cart.item_count > 0;
    foot.hidden = cart.item_count === 0;
    total.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, qty) {
    if (drawer) drawer.classList.add('is-busy');
    return fetch(CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.items) renderCart(cart);
        else if (cart && cart.description) toast(cart.description);
      })
      .catch(function () { toast('Nie udało się zmienić koszyka. Spróbuj ponownie.'); })
      .finally(function () { if (drawer) drawer.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-tk-cart-open]');
    if (openBtn && drawer) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-tk-drawer-close]')) { closeDrawer(); return; }
    var qtyBtn = e.target.closest('[data-tk-qty]');
    if (qtyBtn) {
      var line = qtyBtn.closest('[data-key]');
      if (line) changeLine(line.getAttribute('data-key'), parseInt(qtyBtn.getAttribute('data-tk-qty'), 10));
    }
  });

  if (drawer) {
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var focusables = $$('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])', drawer)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- Formularze produktu ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-tk-product-form]');
    if (!form || !window.fetch || !window.FormData) return;
    e.preventDefault();

    var btn = $('[data-tk-add]', form);
    var errorEl = $('[data-tk-error]', form);
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    if (errorEl) errorEl.hidden = true;

    fetch(ADD_URL, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Nie udało się dodać produktu.');
        return fetchCart().then(function () {
          toast('Dodano do koszyka');
          openDrawer();
        });
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        else toast(err.message);
      })
      .finally(function () {
        if (btn) {
          btn.removeAttribute('aria-busy');
          var select = $('[data-tk-variant-select]', form);
          var opt = select ? select.options[select.selectedIndex] : null;
          btn.disabled = opt ? opt.getAttribute('data-available') !== 'true' : false;
        }
      });
  });

  /* ---------- Warianty ---------- */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-tk-variant-select]');
    if (!select) return;
    var wrap = select.closest('[data-tk-buy]');
    var opt = select.options[select.selectedIndex];
    var available = opt.getAttribute('data-available') === 'true';
    var price = opt.getAttribute('data-price');
    var compare = opt.getAttribute('data-compare');

    var priceNow = $('[data-tk-price-now]', wrap);
    var priceWas = $('[data-tk-price-was]', wrap);
    if (priceNow) priceNow.innerHTML = price;
    if (priceWas) { priceWas.innerHTML = compare || ''; priceWas.hidden = !compare; }

    var btn = $('[data-tk-add]', wrap);
    var label = $('[data-tk-add-label]', wrap);
    if (btn) btn.disabled = !available;
    if (label) label.textContent = available ? wrap.getAttribute('data-label') : 'Chwilowo niedostępny';

    var stock = $('[data-tk-stock]', wrap);
    if (stock) {
      stock.classList.toggle('tk-stock--out', !available);
      $('[data-tk-stock-label]', stock).textContent = available ? 'Dostępny' : 'Chwilowo niedostępny';
    }

    var form = select.form;
    var sticky = $('[data-tk-sticky]');
    if (sticky && form && sticky.getAttribute('data-form') === form.id) {
      var sp = $('[data-tk-sticky-price]', sticky);
      if (sp) sp.innerHTML = price;
      var sb = $('[data-tk-sticky-buy]', sticky);
      if (sb) sb.disabled = !available;
    }
  });

  /* ---------- Przyklejony przycisk zakupu (telefon) ---------- */
  (function () {
    var sticky = $('[data-tk-sticky]');
    if (!sticky) return;
    var form = document.getElementById(sticky.getAttribute('data-form'));
    if (!form) return;
    var finalSection = $('[data-tk-final]');
    var formVisible = true, finalVisible = false;

    sticky.hidden = false;
    function update() {
      var show = !formVisible && !finalVisible;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      $$('button', sticky).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          formVisible = en.isIntersecting;
        });
        update();
      }).observe(form);
      if (finalSection) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { finalVisible = en.isIntersecting; });
          update();
        }).observe(finalSection);
      }
    }
    update();

    $('[data-tk-sticky-buy]', sticky).addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  })();

  /* ---------- Powiększanie zdjęć ---------- */
  (function () {
    var box = $('[data-tk-lightbox]');
    if (!box || typeof box.showModal !== 'function') return;
    var img = $('[data-tk-lightbox-img]', box);
    var cap = $('[data-tk-lightbox-caption]', box);
    var items = [], index = 0;

    function show(i) {
      index = (i + items.length) % items.length;
      var it = items[index];
      img.src = it.getAttribute('data-src');
      img.alt = it.getAttribute('data-alt') || '';
      cap.textContent = it.getAttribute('data-alt') || '';
      cap.hidden = !cap.textContent;
    }
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-tk-zoom]');
      if (!trigger) return;
      e.preventDefault();
      var group = trigger.getAttribute('data-group');
      items = $$('[data-tk-zoom]').filter(function (el) { return el.getAttribute('data-group') === group; });
      box.classList.toggle('is-single', items.length < 2);
      show(items.indexOf(trigger));
      box.showModal();
      document.body.classList.add('tk-lock');
    });
    box.addEventListener('close', function () { document.body.classList.remove('tk-lock'); img.removeAttribute('src'); });
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-tk-lightbox-close]') || e.target === box) box.close();
      else if (e.target.closest('[data-tk-lightbox-prev]')) show(index - 1);
      else if (e.target.closest('[data-tk-lightbox-next]')) show(index + 1);
    });
    box.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(index - 1);
      if (e.key === 'ArrowRight') show(index + 1);
    });
    var startX = null;
    box.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (startX === null || items.length < 2) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) show(index + (dx < 0 ? 1 : -1));
      startX = null;
    });
  })();

  /* ---------- Filmy: odtwarzanie dopiero, gdy są widoczne ---------- */
  (function () {
    var videos = $$('video[data-tk-autoplay="true"]');
    if (!videos.length || reduceMotion || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          v.muted = true;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.5 });
    videos.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); io.observe(v); });
  })();

  /* ---------- Menu mobilne ---------- */
  (function () {
    var menu = $('[data-tk-menu]');
    if (!menu) return;
    menu.addEventListener('click', function (e) {
      if (e.target.closest('[data-tk-menu-link]')) menu.removeAttribute('open');
    });
    document.addEventListener('click', function (e) {
      if (menu.hasAttribute('open') && !menu.contains(e.target)) menu.removeAttribute('open');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.hasAttribute('open')) {
        menu.removeAttribute('open');
        $('summary', menu).focus();
      }
    });
  })();

  /* ---------- Wysokość nagłówka (dla przewijania do sekcji) ---------- */
  (function () {
    var header = $('[data-tk-header]');
    if (!header) return;
    function setH() { document.documentElement.style.setProperty('--tk-header-h', header.offsetHeight + 'px'); }
    setH();
    window.addEventListener('resize', setH, { passive: true });
  })();

  /* Odświeżenie koszyka po powrocie przyciskiem „wstecz” (bfcache) */
  window.addEventListener('pageshow', function (e) { if (e.persisted) fetchCart().catch(function () {}); });
})();
